import FilterSelect from "@/components/FilterSelect";
import FilterGroup from "@/components/FilterSelect/FilterGroup";
import HBCategorySelect from "@/components/HBCategorySelect";
import HBTabButton from "@/components/HBTabButton";
import Image from "@/components/Image";
import { useSearchLimit } from "@/components/LoginModal/useLoginLimit";
import {
  AB_MATERIAL_THEME_OPTIMIZE,
  AB_SEARCH_FEED_WORDS,
  AB_SEARCH_FILTER_PANEL,
  AB_SEARCH_TAB_TEXT,
} from "@/constants/ABMng";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import { SORT_ITEM_MAP, SORT_LIST } from "@/constants/sort";
import { VIEWTYPE3_ITEM_MAP, VIEWTYPE3_LIST } from "@/constants/viewType";
import useAppStore from "@/context/store";
import SearchEmpty from "@/pageComponents/Search/SearchEmpty";
import FilterPanel from "@/pageComponents/Search/SearchFilter/FilterPanel";
import SearchBoardList from "@/pageComponents/SearchBoardList";
import SearchPinList from "@/pageComponents/SearchPinList";
import SearchUserList from "@/pageComponents/SearchUserList";
import { setSearch } from "@/tracker/shared/global";
import filterUrlParams from "@/utils/filterUrlParams";
import useABTest from "@/utils/hooks/useABtest";
import { useCloseToday } from "@/utils/hooks/useCloseToday";
import { useListenScrollDirection } from "@/utils/hooks/useListenScrollDirection";
import { useIsMaterialVip } from "@/utils/hooks/useVip";
import isDuringSpecial from "@/utils/isDuringSpecial";
import useSideNavCollapse from "@/utils/useSideNavCollapse";
import constantFactory from "@gaoding/constant-factory";
import { useMount } from "ahooks";
import { Tabs } from "antd";
import classNames from "classnames";
import Head from "next/head";
import router from "next/router";
import { useEffect, useMemo, useState } from "react";
import { When } from "react-if";
import SearchMaterialList from "../../pageComponents/SearchMaterialList";
import { getSearchWordsRecommend } from "../../services";
import styles from "./index.module.less";
import PageInfo from "./PageInfo";
import RecommendTopic from "./RecommendTopic";
import RecommendMaterial from "./RecommendTopic/material";
import FilterToggleButton from "./SearchFilter/FilterToggleButton";
const TabPane = Tabs.TabPane;
const isSpecialTime = isDuringSpecial();
const MATERIAL_CATEGORY = "material_category";

const TYPE = {
  material: "material",
  pin: "pin",
  board: "board",
  user: "user",
};
const TABHEIGHT = 60;

// 是否显示筛选面板的 Hook
const useFilterPanelVisible = () => {
  // 搜索筛选面板AB
  const searchFilterPanelAB = useABTest(AB_SEARCH_FILTER_PANEL);

  return searchFilterPanelAB.new;
};

export default function Search({
  searchResult,
  serverSideFacets,
  serverSidePinFilters,
  serverSideMaterialFilters,
  pageInfo,
  ...props
}) {
  const [visible, setVisible] = useState(true);
  const [cardType, setCardType] = useState("card");
  const [categoriesList, setCategoriesList] = useState({
    pin: [],
    board: [],
    material: [],
    user: [],
  });
  let {
    type: originalType,
    q,
    category,
    sort,
    color,
    fileType,
    material,
    ratio,
    resolution,
    filterIds,
  } = props; // 搜索类型

  const { isFilterVisible } = useAppStore((state) => ({
    isFilterVisible: state.isFilterVisible,
  }));

  const [type, setType] = useState(originalType || TYPE.pin);

  const { onSearchLimitCheck } = useSearchLimit();

  const [recommend, setRecommend] = useState();
  const [recommendSearchWords, setRecommendSearchWords] = useState([]);

  const { column: columnNum } = useAppStore(({ column }) => ({
    column,
  }));

  // 是否显示筛选面板
  const isFilterPanelVisible = useFilterPanelVisible();

  // 推荐搜索词AB测试
  const searchFeedWordsAB = useABTest(AB_SEARCH_FEED_WORDS);

  const [recommendTopicClosed, onCloseRecommend] = useCloseToday(
    LOCAL_STORAGE_KEY.HB_SEARCH_RECOMMEND
  );

  const hasRecommend = useMemo(() => {
    // 是否有搜索推荐内容
    const hasContent =
      (recommend?.recommend || recommend?.recommendMaterial) &&
      (type === TYPE.pin || type === TYPE.material);

    // 有内容且没有关闭
    return hasContent && !recommendTopicClosed;
  }, [recommendTopicClosed, recommend, type]);

  const ab = useABTest(AB_SEARCH_TAB_TEXT);

  //  结果页推荐专题优化
  const recommendResultTest = useABTest(AB_MATERIAL_THEME_OPTIMIZE);

  const setSearchFilterOne = (type) => {
    const filterOne = tabList.find((item) => item.value === type)?.name;
    setSearch({
      filter_one: [filterOne],
    });
  };

  useEffect(() => {
    const type = router.query.type;
    setSearchFilterOne(type);
  }, []);

  useEffect(() => {
    const typeList = ["pin", "board", "material", "user"];
    if (typeList.includes(originalType)) {
      setType(originalType);
    } else {
      setType(TYPE.pin);
    }
  }, [originalType]);

  const onChangeTab = async (data) => {
    await onSearchLimitCheck();

    setSearchFilterOne(data.value);

    router.push({
      pathname: "/search",
      query: { type: data.value, q },
    });
  };

  const onChange = async (data, key, isFilter) => {
    await onSearchLimitCheck();

    setSearch({
      search_type: "筛选器-点击",
    });
    const query = {
      q,
      ...(category ? { category } : null),
      ...(sort ? { sort } : null),
      ...(color ? { color } : null),
      ...(fileType ? { file_type: fileType } : null),
      ...(material ? { material: material } : null),
      ...(ratio ? { ratio } : null),
      ...(resolution ? { resolution } : null),
      ...(type ? { type } : null),
      ...(filterIds ? { filter_ids: filterIds } : null),
    };
    if (isFilter) {
      const filterIdsMap = filterIds ? filterUrlParams.decode(filterIds) : {};
      if (data?.value) {
        filterIdsMap[key] = data?.value;
      } else {
        delete filterIdsMap[key];
      }
      if (Object.keys(filterIdsMap).length > 0) {
        query.filter_ids = filterUrlParams.encode(filterIdsMap);
      } else {
        delete query.filter_ids;
      }
    } else if (data?.value) {
      query[key] = data.value;
    } else {
      delete query[key];
    }
    router.push(
      {
        pathname: "/search",
        query: query,
      },
      undefined,
      {
        shallow: router.pathname === "/search",
      }
    );
  };
  const categories = useMemo(() => {
    let result =
      categoriesList[type]?.map((i) => {
        return { ...i, key: i.id, label: i.name, value: i.value };
      }) || [];
    return constantFactory("CATEGORY", result);
  }, [categoriesList, type]);

  const selectMap = useMemo(() => {
    const filterIdsMap = filterIds ? filterUrlParams.decode(filterIds) : {};

    return {
      pin: [
        {
          name: isFilterPanelVisible ? "排序" : "综合排序",
          options: SORT_LIST,
          value: SORT_ITEM_MAP[sort],
          key: "sort",
          allowClear: false,
        },
        ...(serverSidePinFilters?.map((item) => {
          const value = item?.options?.find(
            (option) => filterIdsMap[item?.key] === option?.value
          );
          return {
            ...item,
            value: value || null,
          };
        }) || []),
      ],
      board: [
        {
          name: isFilterPanelVisible ? "排序" : "综合排序",
          options: SORT_LIST,
          value: SORT_ITEM_MAP[sort],
          key: "sort",
          allowClear: false,
        },
        {
          name: "分类",
          options: categories.CATEGORY_LIST,
          value: categories.CATEGORY_ITEM_MAP
            ? categories.CATEGORY_ITEM_MAP[category]
            : undefined,
          key: "category",
        },
      ],
      material: [
        {
          name: isFilterPanelVisible ? "排序" : "综合排序",
          options: SORT_LIST,
          value: SORT_ITEM_MAP[sort],
          key: "sort",
          allowClear: false,
        },
        ...(serverSideMaterialFilters?.map((item) => {
          const value = item?.options?.find(
            (option) => filterIdsMap[item?.key] === option?.value
          );
          return {
            ...item,
            value: value || null,
            hidden: item.key === MATERIAL_CATEGORY,
          };
        }) || []),
      ],
      user: [
        {
          name: "视图",
          options: VIEWTYPE3_LIST,
          value: VIEWTYPE3_ITEM_MAP[cardType],
          key: "view",
          allowClear: false,
          onChange: (_) => {
            setCardType(_.value);
          },
        },
      ],
    };
  }, [
    cardType,
    filterIds,
    sort,
    serverSidePinFilters,
    categories,
    category,
    serverSideMaterialFilters,
    isFilterPanelVisible,
  ]);
  // 素材分类单独取出来展开
  const materialCategoryFilter = useMemo(() => {
    return serverSideMaterialFilters?.find(
      (item) => item.key === MATERIAL_CATEGORY
    );
  }, [serverSideMaterialFilters]);

  const isVip = useIsMaterialVip();

  // 是否显示素材标识
  const isShowMaterialTag = useMemo(() => {
    if (isVip) {
      return true;
    }

    return !!selectMap?.pin?.find((item) => {
      if (item?.key === "is_material" && item?.value?.label === "仅看素材") {
        return true;
      }
    });
  }, [selectMap, isVip]);

  useEffect(() => {
    // 搜索词切换时候，需要重置搜索tab的状态
    setVisible(true);
  }, [q]);

  // 获取推荐搜索词
  const fetchRecommendSearchWords = useMemo(() => {
    return async () => {
      if (!q) return;

      // AB测试判断：只有当AB_SEARCH_FEED_WORDS为new时才调用接口
      if (!searchFeedWordsAB.new) {
        setRecommendSearchWords([]);
        return;
      }

      try {
        const result = await getSearchWordsRecommend({ q });
        setRecommendSearchWords(result || []);
      } catch (error) {
        console.error("获取推荐搜索词失败:", error);
        setRecommendSearchWords([]);
      }
    };
  }, [q, searchFeedWordsAB.new]);

  useEffect(() => {
    fetchRecommendSearchWords();
  }, [fetchRecommendSearchWords]);

  useListenScrollDirection(
    () => setVisible(true),
    () => {
      const height = hasRecommend ? TABHEIGHT * 2 + 378 : TABHEIGHT * 2;
      if (window.scrollY > height) {
        setVisible(false);
      }
    }
  );
  const materialCategory = useMemo(() => {
    if (type !== TYPE.material) {
      return undefined;
    }
    return selectMap[TYPE.material].find((i) => i.key === MATERIAL_CATEGORY)
      ?.value?.value;
  }, [selectMap, type]);

  const tabList = useMemo(() => {
    return [
      {
        name: "采集",
        value: "pin",
        href: `/search?type=pin&q=${q}`,
      },
      {
        name: "画板",
        value: "board",
        href: `/search?type=board&q=${q}`,
      },
      ...(isSpecialTime
        ? []
        : [
            {
              name: "用户",
              value: "user",
              href: `/search?type=user&q=${q}`,
            },
          ]),

      {
        name: (
          <>
            {ab.planA ? "商用素材" : "源文件"}
            <Image
              src="https://st0.dancf.com/static/02/202401300356-0f8c.gif"
              className={styles.rightIcon}
              alt="ic_copyright"
              width={16}
              height={16}
            />
          </>
        ),
        value: "material",
        href: `/search?type=material&q=${q}`,
        trackerProps: {
          "data-gd-click": "resource_loc_click",
          "data-gd-expose": "resource_loc_expose",
          "data-resource-type": "文字链",
          "data-resource-id": "0",
          "data-resource-title": ab.planA ? "商用素材" : "源文件",
          "data-content-source": "筛选项",
        },
      },
    ];
  }, [ab, q]);

  const is_material = recommend?.recommendType === "material";

  useMount(() => {
    if (window.__NEXT_DATA__.page === "/search") {
      // 当前搜索页面刷新，触未登录搜索限制
      onSearchLimitCheck();
    }
  });

  // 推荐专题列表列数
  const recommendTopicListColNum = useMemo(() => {
    // 规则: 瀑布流: 小于5列, 广告位展示占2列,大于等于5列, 广告位展示占3列, 最多3列
    if (columnNum < 5) {
      return 2;
    }

    return 3;
  }, [columnNum]);

  const [isCollapsed] = useSideNavCollapse();

  return (
    <div
      className={classNames(styles.search, {
        [styles.withFilterPanel]: isCollapsed && isFilterPanelVisible,
        [styles.withFilterPanelVisible]:
          isCollapsed && isFilterPanelVisible && isFilterVisible,
      })}
      data-content-source="信息流"
    >
      <Head>
        <title>{q} - 搜索结果 - 花瓣</title>
      </Head>
      {/* <div
        className={classNames([
          styles.searchHeader,
          styles.space,
          "modalOpenWidth",
        ])}
      ></div> */}
      {hasRecommend &&
        (recommendResultTest.value === "string_0" ||
          recommendResultTest.value === "string_5") &&
        (!is_material ? (
          <div
            className={classNames(
              styles.recommendContainer,
              "calculateWrapper"
            )}
          >
            <RecommendTopic
              searchWord={q}
              topics={recommend}
              onClose={onCloseRecommend}
            />
          </div>
        ) : (
          <div
            className={classNames(
              styles.recommendContainer,
              "calculateWrapper"
            )}
          >
            <RecommendMaterial
              searchWord={q}
              recommend={recommend}
              onClose={onCloseRecommend}
            />
          </div>
        ))}
      {isFilterPanelVisible ? (
        <>
          <FilterPanel
            filters={selectMap[type]}
            visible={isFilterVisible}
            tabList={tabList}
            onTabChange={onChangeTab}
          />
        </>
      ) : (
        <div
          className={classNames(styles.searchHeader, "modalOpenWidth", {
            [styles.active]: visible,
          })}
        >
          <div className={classNames(styles.wrapper, "calculateWrapper")}>
            <HBTabButton
              className={styles.hbTab}
              options={tabList}
              onChange={onChangeTab}
              value={type}
            ></HBTabButton>
            <When condition={type === TYPE.material}>
              <div className={styles.categoryConent}>
                <HBCategorySelect
                  allText={"全部"}
                  minWidth={500}
                  maxWidth={600}
                  onChange={(data) => onChange(data, MATERIAL_CATEGORY, true)}
                  value={materialCategory}
                  options={materialCategoryFilter?.options}
                />
              </div>
            </When>
            <div className={styles.right}>
              <FilterGroup>
                {selectMap[type]?.map((i, index) => {
                  const select = (
                    <FilterSelect
                      onChange={(value) => {
                        onChange(value, i.key, i.isFilter);
                      }}
                      {...i}
                      key={i.key}
                      className={classNames(styles.select, {
                        [styles.selectFirst]: index === 0,
                      })}
                    />
                  );
                  if (i.options?.length && !i.hidden) {
                    return select;
                  }
                  return null;
                })}
              </FilterGroup>
            </div>
          </div>
        </div>
      )}
      {pageInfo && <PageInfo {...pageInfo} />}
      <Tabs
        activeKey={type}
        destroyInactiveTabPane={true}
        onChange={onChangeTab}
        className={classNames(styles.tabs, "calculateWrapper", "wrapper")}
        // tabBarStyle={{ top: `${height}px`,transform:'.5' }}
        centered
      >
        <TabPane tab="采集" key={TYPE.pin}>
          <SearchPinList
            query={props}
            searchResult={searchResult}
            serverSideFacets={serverSideFacets}
            serverSidePinFilters={serverSidePinFilters}
            type={type}
            showMaterialTag={isShowMaterialTag}
            setRecommend={setRecommend}
            recommend={recommend}
            recommendResultTest={recommendResultTest}
            recommendTopicListColNum={recommendTopicListColNum}
            isFilterPanelVisible={isFilterPanelVisible}
            recommendSearchWords={recommendSearchWords}
          />
        </TabPane>
        <TabPane tab="画板" key={TYPE.board}>
          {isFilterPanelVisible && <FilterToggleButton />}
          <SearchBoardList
            setCategoriesList={setCategoriesList}
            query={props}
            empty={<SearchEmpty />}
            searchResult={searchResult}
            serverSideFacets={serverSideFacets}
          />
        </TabPane>
        <TabPane tab="素材" key={TYPE.material}>
          <SearchMaterialList
            query={props}
            empty={<SearchEmpty />}
            searchResult={searchResult}
            serverSideMaterialFilters={serverSideMaterialFilters}
            setRecommend={setRecommend}
            recommend={recommend}
            recommendResultTest={recommendResultTest}
            recommendTopicListColNum={recommendTopicListColNum}
            isFilterPanelVisible={isFilterPanelVisible}
            searchWord={q}
            onClose={onCloseRecommend}
            recommendSearchWords={recommendSearchWords}
          />
        </TabPane>
        {!isSpecialTime ? (
          <TabPane tab="用户" key={TYPE.user}>
            {isFilterPanelVisible && <FilterToggleButton />}
            <SearchUserList
              query={props}
              cardType={cardType}
              empty={<SearchEmpty />}
              searchResult={searchResult}
            />
          </TabPane>
        ) : null}
      </Tabs>
    </div>
  );
}
